import { Ng2StateDeclaration } from '@uirouter/angular';
import { BusinessAreaEditComponent } from '@fi-app/business-area/business-area-edit/business-area-edit.component';
import { BusinessAreaService } from '@fi-app/business-area/business-area.service';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

export const FiBusinessAreaAddState: Ng2StateDeclaration = {
    name: FiStateNames.BusinessArea.Add,
    url: '/Add',
    views: {
        '@': {
            component: BusinessAreaEditComponent,
        },
    },
    resolve: {
        businessArea: [BusinessAreaService, FiBusinessAreaAddStateResolve_businessArea],
        pageTitle: [PageTitleService, 'businessArea', FiBusinessAreaAddStateResolve_pageTitle],
    },
};

export function FiBusinessAreaAddStateResolve_businessArea(businessAreaService: BusinessAreaService) {
    return businessAreaService.GetBusinessArea(0);
}

export function FiBusinessAreaAddStateResolve_pageTitle(ccmPageTitle: PageTitleService, businessArea) {
    return ccmPageTitle.setTitleByItem(businessArea);
}
